import { render } from "./ButtonProceed.vue?vue&type=template&id=c1094cda&ts=true"
import script from "./ButtonProceed.vue?vue&type=script&lang=ts"
export * from "./ButtonProceed.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uatcomp/public_html/wizards/travel-insurance-wizard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__